import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import Skeleton from 'react-loading-skeleton';
import Actions from '../../../Actions';
import Paginate from '../Layout/Paginate';
import CompanyRow from './CompanyRow';
import CompanyAdd from './Add';
import Edit from './Edit';
import Tile from '../Layout/Tile';
import Filter from '../Layout/Filter';


class CompanyList extends Component {

    componentDidMount = () => {
        const { auth, getCompanies } = this.props;
        getCompanies(auth.token, {page: 1, order: "asc", sort: "name" }, false);
    }

    edit = (id) => {
        const { companies, toggleModal, setModalData } = this.props;
        if(companies.hasOwnProperty(id)){
            setModalData("companies","edit",companies[id]);
            toggleModal("companies","edit");
        }
    }

    companiesLoading = () => {
        const data = [];
        for(let i=0;i<10;i++){
            data.push(
                <Tile key={i+"-loading"} xs="12" style={{padding: "1vh 1vw"}} className="mx-auto">
                    <Skeleton count={4}/>
                </Tile>
            );
        }

        return data;
    }

    companies = () => {
        const { companies, companiesMeta } = this.props;
        const rows = [];
        const { data = [] } = companiesMeta;
        data.map((id) => {
            rows.push(
                <CompanyRow key={id} edit={this.edit} company={companies[id]}/>
            );
        });
        return rows;
    }

    render(){
        const { getCompanies, companiesLoading, companiesMeta, query } = this.props;
        return (
            <div style={{ padding: "3px"}}>        
               {companiesLoading ? this.companiesLoading():
                    <div>
                        <Table responsive className="text-left">
                            <thead>
                                <tr>
                                    <th className="text-nowrap">
                                        <Filter query={query} id="name" title="Name" field="name" filter={getCompanies} />
                                    </th>
                                    <th className="text-nowrap">
                                        <Filter query={query} id="short_name" title="Short Name" field="short_name" filter={getCompanies} />
                                    </th>
                                    <th className="text-nowrap">
                                        <Filter query={query} id="type" title="Type" field="type" filter={getCompanies} />
                                    </th>
                                    <th className="text-nowrap">
                                        <Filter query={query} id="address" title="Address" field="address" filter={getCompanies} />
                                    </th>
                                    <th className="text-nowrap">
                                        <Filter query={query} id="website" title="Website" field="website" filter={getCompanies} />
                                    </th>
                                    <th className="text-nowrap">
                                        <Filter query={query} id="contact_name" title="Contact Name" field="contact_name" filter={getCompanies} />
                                    </th>
                                    <th className="text-nowrap">
                                        <Filter query={query} id="contact_email" title="Contact Email" field="contact_email" filter={getCompanies} />
                                    </th>
                                    <th className="text-nowrap">
                                        <Filter query={query} id="contact_phone" title="Contact Phone" field="contact_phone" filter={getCompanies} />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.companies()}
                            </tbody>
                        </Table>
                        <Paginate fetch={getCompanies} meta={companiesMeta}  />
                        <CompanyAdd />
                        <Edit />
                    </div>
               }
            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    auth: state.auth,
    companies: state.companyStore.companies,
    companiesMeta: state.companyStore.companiesMeta,
    query: state.companyStore.query,
    companiesLoading: state.companyStore.companiesLoading,
});

const { companies, modals } = Actions;

export default connect(mapStateToProps,{ ...companies, ...modals })(CompanyList);


// WEBPACK FOOTER //
// ./src/Components/App/Companies/CompanyList.js